import React, { useEffect } from "react";
import { Images } from "../../helper/images";
import { useAppContext } from "../../context/app.context";
import { Constant } from "../../helper/constant";

const AIRoadmapTable = () => {

    const { aiMaturityEval, getAIMaturityEvaluation } = useAppContext();

    useEffect(() => {
        if (!aiMaturityEval) {
            getAIMaturityEvaluation();
        }
    }, [aiMaturityEval]);

    const getTaskStatus = (index, key) => {
        const content = aiMaturityEval && aiMaturityEval[index] && aiMaturityEval[index].stages[key] ? aiMaturityEval[index].stages[key] : {};
        return !content.show
    }


    const renderAIData = () => {
        const AI_DATA_0 = getTaskStatus(6, Constant.AI_DATA[0]);
        const AI_DATA_1 = getTaskStatus(6, Constant.AI_DATA[1]);
        const AI_DATA_2 = getTaskStatus(6, Constant.AI_DATA[2]);
        const AI_DATA_3 = getTaskStatus(6, Constant.AI_DATA[3]);
        const AI_DATA_4 = getTaskStatus(6, Constant.AI_DATA[4]);
        const AI_DATA_5 = getTaskStatus(6, Constant.AI_DATA[5]);
        const AI_DATA_6 = getTaskStatus(6, Constant.AI_DATA[6]);
        const AI_DATA_7 = getTaskStatus(6, Constant.AI_DATA[7]);
        const AI_DATA_8 = getTaskStatus(6, Constant.AI_DATA[8]);

        return (
            <table className="ai-table ai-strategy-table-roadmap">
                <tbody>
                    <tr>
                        <td className="row-header ai-Data" style={{ width: 160 }}>
                            <div className="row-header-wrap">
                                <div><img src={Images.icon7} alt="" /></div>
                                <div> AI Data</div>
                            </div>
                        </td>
                        <td className="vertical-align-top" style={{ backgroundColor: '#f1f1f1' }}>
                            <div className="ai-Data-roadmap-wrap">
                                <div className="ai-Data-roadmap-item ai-Data-line2" style={{ minWidth: 155 }}>
                                    <div className={`ai-Data-roadmap-item-box ai-Data-line2 ${AI_DATA_0 ? '' : 'disabled-timeline'}`}>
                                        Assess data readiness for <br /> initial Ai use cases
                                    </div>
                                    <span className="ai-Data-item-one-line"></span>
                                    <span className="ai-Data-item-one-line2"></span>
                                    <span className="ai-Data-item-one-line3"></span>
                                </div>
                                <div className="ai-Data-roadmap-item ai-Data-line2" style={{ minWidth: 155 }}>
                                    <div className={`ai-Data-roadmap-item-box ai-Data-line2 ${AI_DATA_1 ? '' : 'disabled-timeline'}`}>
                                        Implement data readiness plan
                                    </div>
                                    <div className={`ai-Data-roadmap-item-box ai-Data-line2 ${AI_DATA_2 ? '' : 'disabled-timeline'}`} style={{ marginTop: 275 }}>
                                        Build data analytics fo AI
                                    </div>
                                    <span className="ai-Data-item-two-line"></span>
                                    <span className="ai-Data-item-two-line2"></span>
                                    <span className="ai-Data-item-two-line3"></span>
                                    <span className="ai-Data-item-two-line4"></span>
                                    <span className="ai-Data-item-two-line5"></span>
                                </div>
                                <div className="ai-Data-roadmap-item ai-Data-line2" style={{ minWidth: 155 }}>
                                    <div className={`ai-Data-roadmap-item-box ai-Data-line2 ${AI_DATA_3 ? '' : 'disabled-timeline'}`}>
                                        Gain buy-in to evolve data <br /> capabilities for AI
                                    </div>
                                    <div className={`ai-Data-roadmap-item-box ai-Data-line2 ${AI_DATA_4 ? '' : 'disabled-timeline'}`} style={{ marginTop: 70 }}>
                                        Extend data governance to support AI
                                    </div>
                                    <span className="ai-Data-item-three-line"></span>
                                    <span className="ai-Data-item-three-line2"></span>
                                    <span className="ai-Data-item-three-line3"></span>
                                    <span className="ai-Data-item-three-line4"></span>
                                </div>
                                <div className="ai-Data-roadmap-item ai-Data-line2" style={{ minWidth: 155 }}>
                                    <div className={`ai-Data-roadmap-item-box ai-Data-line2 ${AI_DATA_5 ? '' : 'disabled-timeline'}`}>
                                        evolve data capabilities for AI
                                    </div>
                                    <div className={`ai-Data-roadmap-item-box ai-Data-line2 ${AI_DATA_6 ? '' : 'disabled-timeline'}`} style={{ marginTop: 70 }}>
                                        Establish an AI data quality framework
                                    </div>
                                    <div className={`ai-Data-roadmap-item-box ai-Data-line2 ${AI_DATA_7 ? '' : 'disabled-timeline'}`}>
                                        Asapt meradata practices for AI
                                    </div>
                                    <div className={`ai-Data-roadmap-item-box ai-Data-line2 ${AI_DATA_8 ? '' : 'disabled-timeline'}`} style={{ marginTop: 70 }}>
                                        Implement data observability for AI
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }


    const renderAIEnigneering = () => {
        const AI_ENGINEERING_0 = getTaskStatus(5, Constant.AI_ENGINEERING[0]);
        const AI_ENGINEERING_1 = getTaskStatus(5, Constant.AI_ENGINEERING[1]);
        const AI_ENGINEERING_2 = getTaskStatus(5, Constant.AI_ENGINEERING[2]);
        const AI_ENGINEERING_3 = getTaskStatus(5, Constant.AI_ENGINEERING[3]);
        const AI_ENGINEERING_4 = getTaskStatus(5, Constant.AI_ENGINEERING[4]);
        const AI_ENGINEERING_5 = getTaskStatus(5, Constant.AI_ENGINEERING[5]);
        const AI_ENGINEERING_6 = getTaskStatus(5, Constant.AI_ENGINEERING[6]);
        const AI_ENGINEERING_7 = getTaskStatus(5, Constant.AI_ENGINEERING[7]);
        const AI_ENGINEERING_8 = getTaskStatus(5, Constant.AI_ENGINEERING[8]);
        const AI_ENGINEERING_9 = getTaskStatus(5, Constant.AI_ENGINEERING[9]);
        return (
            <table className="ai-table ai-strategy-table-roadmap">
                <tbody>
                    <tr>
                        <td className="row-header ai-Engineering" style={{ width: 145, maxWidth: 150 }}>
                            <div className="row-header-wrap">
                                <div><img src={Images.icon6} alt="AI engineering" /></div>
                                <div>AI engineering</div>
                            </div>
                        </td>
                        <td className="vertical-align-top" style={{ backgroundColor: '#f1f1f1' }}>
                            <div className="ai-Engineering-roadmap-wrap">
                                <div className="ai-Engineering-roadmap-item ai-Engineering-line2" style={{ minWidth: 155 }}>
                                    <div className={`ai-Engineering-roadmap-item-box ai-Engineering-line2 ${AI_ENGINEERING_0 ? '' : 'disabled-timeline'} `}>
                                        Establish build vs buy <br />framework
                                    </div>
                                    <span className="ai-Engineering-item-one-line"></span>
                                    <span className="ai-Engineering-item-one-line2"></span>
                                    <span className="ai-Engineering-item-one-line3"></span>
                                    <span className="ai-Engineering-item-one-line4"></span>
                                </div>
                                <div className="ai-Engineering-roadmap-item ai-Engineering-line2" style={{ minWidth: 135 }}>
                                    <div className={`ai-Engineering-roadmap-item-box ai-Engineering-line2 ${AI_ENGINEERING_1 ? '' : 'disabled-timeline'} `}>
                                        Setup a sandbox <br /> environment
                                    </div>
                                    <span className="ai-Engineering-item-two-line"></span>
                                    <span className="ai-Engineering-item-two-line2"></span>
                                </div>
                                <div className="ai-Engineering-roadmap-item ai-Engineering-line2" style={{ minWidth: 190 }}>
                                    <div className={`ai-Engineering-roadmap-item-box ai-Engineering-line2 ${AI_ENGINEERING_2 ? '' : 'disabled-timeline'} `}>
                                        Select vendors for initial AI <br /> use cases
                                    </div>
                                    <span className="ai-Engineering-item-three-line"></span>
                                    <span className="ai-Engineering-item-three-line2"></span>
                                </div>
                                <div className="ai-Engineering-roadmap-item ai-Engineering-line2" style={{ minWidth: 155 }}>
                                    <div className={`ai-Engineering-roadmap-item-box ai-Engineering-line2 ${AI_ENGINEERING_3 ? '' : 'disabled-timeline'} `}>
                                        Develop a library <br />of design patterns
                                    </div>
                                    <span className="ai-Engineering-item-four-line"></span>

                                </div>
                                <div className="ai-Engineering-roadmap-item ai-Engineering-line2" style={{ minWidth: 235 }}>
                                    <div className={`ai-Engineering-roadmap-item-box ai-Engineering-line2 ${AI_ENGINEERING_4 ? '' : 'disabled-timeline'} `}>
                                        Create an AI vendor <br />and application strategy
                                    </div>

                                </div>

                                <div className="ai-Engineering-roadmap-item ai-Engineering-line2" style={{ minWidth: 165 }}>
                                    <div className={`ai-Engineering-roadmap-item-box ai-Engineering-line2 ${AI_ENGINEERING_5 ? '' : 'disabled-timeline'} `}>
                                        Define AI reference <br />architecture
                                    </div>
                                    <span className="ai-Engineering-item-five-line"></span>
                                    <span className="ai-Engineering-item-five-line2"></span>
                                </div>

                                <div className="ai-Engineering-roadmap-item ai-Engineering-line2" style={{ minWidth: 155 }}>
                                    <div className={`ai-Engineering-roadmap-item-box ai-Engineering-line2 ${AI_ENGINEERING_6 ? '' : 'disabled-timeline'} `}>
                                        Establish MLOps/ <br /> ModelOps practice
                                    </div>
                                    <span className="ai-Engineering-item-six-line"></span>
                                    <span className="ai-Engineering-item-six-line2"></span>
                                    <span className="ai-Engineering-item-six-line3"></span>
                                    <span className="ai-Engineering-item-six-line4"></span>
                                </div>

                                <div className="ai-Engineering-roadmap-item ai-Engineering-line2" style={{ minWidth: 185 }}>
                                    <div className={`ai-Engineering-roadmap-item-box ai-Engineering-line2 ${AI_ENGINEERING_7 ? '' : 'disabled-timeline'} `}>
                                        Set up an AI observability system
                                    </div>
                                    <div className={`ai-Engineering-roadmap-item-box ai-Engineering-line2 ${AI_ENGINEERING_8 ? '' : 'disabled-timeline'} `}>
                                        Design and embed AI UI/UX best practices
                                    </div>
                                    <div className={`ai-Engineering-roadmap-item-box ai-Engineering-line2 ${AI_ENGINEERING_9 ? '' : 'disabled-timeline'} `}>
                                        Stand up AI platform engineering
                                    </div>

                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }

    const renderAIStrategy = () => {
        const AI_STRATEGY_0 = getTaskStatus(0, Constant.AI_STRATEGY[0]);
        const AI_STRATEGY_1 = getTaskStatus(0, Constant.AI_STRATEGY[1]);
        const AI_STRATEGY_2 = getTaskStatus(0, Constant.AI_STRATEGY[2]);
        const AI_STRATEGY_3 = getTaskStatus(0, Constant.AI_STRATEGY[3]);
        const AI_STRATEGY_4 = getTaskStatus(0, Constant.AI_STRATEGY[4]);
        const AI_STRATEGY_5 = getTaskStatus(0, Constant.AI_STRATEGY[5]);
        const AI_STRATEGY_6 = getTaskStatus(0, Constant.AI_STRATEGY[6]);
        const AI_STRATEGY_7 = getTaskStatus(0, Constant.AI_STRATEGY[7]);
        const AI_STRATEGY_8 = getTaskStatus(0, Constant.AI_STRATEGY[8]);
        return (<table className="ai-table ai-strategy-table-roadmap">
            <tbody>
                <tr>
                    <td className="row-header ai-strategy" style={{ width: 160 }}>
                        <div className="row-header-wrap">
                            <div><img src={Images.icon1} alt="AI Strategy" /></div>
                            <div>AI Strategy</div>
                        </div>
                    </td>
                    <td className="vertical-align-top" style={{ backgroundColor: '#f1f1f1' }}>
                        <div className="ai-strategy-roadmap-wrap">
                            <div className="ai-strategy-roadmap-item" style={{ minWidth: 90 }}>
                                <div className={`ai-strategy-roadmap-item-box ai-strategy-line-20 ai-strategy-line-height-20 ${AI_STRATEGY_0 ? '' : 'disabled-timeline'}`}>
                                    Define the <br /> AI Vision
                                </div>
                                <span className="ai-strategy-item-down-line"></span>
                                <span className="ai-strategy-item-one-line2"></span>
                                <span className="ai-strategy-item-one-line3"></span>
                                <span className="ai-strategy-item-one-line4"></span>
                            </div>
                            <div className="ai-strategy-roadmap-item" style={{ minWidth: 90, marginLeft: -5 }}>
                                <div className={`ai-strategy-roadmap-item-box ai-strategy-line-20 ai-strategy-line-height-20 ${AI_STRATEGY_1 ? '' : 'disabled-timeline'}`}>Measure AI <br /> maturity</div>
                                <div className={`ai-strategy-roadmap-item-box ai-strategy-line-20 ai-strategy-line-height-20 ${AI_STRATEGY_2 ? '' : 'disabled-timeline'}`}>
                                    Anzlyzr external <br /> trends</div>
                                <span className="ai-strategy-item-two-line"></span>
                                <span className="ai-strategy-item-two-line2"></span>
                                <span className="ai-strategy-item-two-line3"></span>


                            </div>
                            <div className="ai-strategy-roadmap-item" style={{ minWidth: 120, marginLeft: 15 }}>
                                <div className={`ai-strategy-roadmap-item-box ml-3 ai-strategy-line2 ${AI_STRATEGY_3 ? '' : 'disabled-timeline'}`}>
                                    Initiate AI <br />Strategy
                                </div>
                                <span className="ai-strategy-item-three-line"></span>
                                <span className="ai-strategy-item-three-line2"></span>
                                <span className="ai-strategy-item-three-line3"></span>
                                <span className="ai-strategy-item-three-line4"></span>
                                <span className="ai-strategy-item-three-line5"></span>
                                <span className="ai-strategy-item-three-line6"></span>
                                <span className="ai-strategy-item-three-line7"></span>
                            </div>
                            <div className="ai-strategy-roadmap-item" style={{ minWidth: 90, marginLeft: 10 }}>
                                <div className={`ai-strategy-roadmap-item-box ai-strategy-item-side-line-arrow-one ${AI_STRATEGY_4 ? '' : 'disabled-timeline'}`}>
                                    Communicate the <br /> AI strategy
                                </div>
                                <div className={`ai-strategy-roadmap-item-box ai-strategy-item-side-line-arrow-two ${AI_STRATEGY_5 ? '' : 'disabled-timeline'}`}>
                                    Set adoption goals for <br /> AI roadmap
                                </div>
                                <div className={`ai-strategy-roadmap-item-box ai-strategy-item-side-line-arrow-three ${AI_STRATEGY_6 ? '' : 'disabled-timeline'}`}>
                                    Identify priorities for AI <br /> portfolio
                                </div>
                                <span className="ai-strategy-item-four-line"></span>
                                <span className="ai-strategy-item-four-line2"></span>
                                <span className="ai-strategy-item-four-line3 "></span>
                            </div>
                            <div className="ai-strategy-roadmap-item ml-3" style={{ minWidth: 120, marginLeft: 25 }}>
                                <div className={`ai-strategy-roadmap-item-box ai-strategy-line3 ${AI_STRATEGY_7 ? '' : 'disabled-timeline'}`}>
                                    Measure AI strategy success</div>
                                <div className={`ai-strategy-roadmap-item-box ai-strategy-line3 ${AI_STRATEGY_8 ? '' : 'disabled-timeline'}`}>
                                    Establish process to refine  <br /> the AI strategy</div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>)
    }

    const renderAIValue = () => {
        const AI_VALUE_0 = getTaskStatus(1, Constant.AI_VALUE[0]);
        const AI_VALUE_1 = getTaskStatus(1, Constant.AI_VALUE[1]);
        const AI_VALUE_2 = getTaskStatus(1, Constant.AI_VALUE[2]);
        const AI_VALUE_3 = getTaskStatus(1, Constant.AI_VALUE[3]);
        const AI_VALUE_4 = getTaskStatus(1, Constant.AI_VALUE[4]);
        const AI_VALUE_5 = getTaskStatus(1, Constant.AI_VALUE[5]);
        const AI_VALUE_6 = getTaskStatus(1, Constant.AI_VALUE[6]);
        const AI_VALUE_7 = getTaskStatus(1, Constant.AI_VALUE[7]);
        const AI_VALUE_8 = getTaskStatus(1, Constant.AI_VALUE[8]);
        const AI_VALUE_9 = getTaskStatus(1, Constant.AI_VALUE[9]);
        return (
            <table className="ai-table ai-strategy-table-roadmap">
                <tbody>
                    <tr>
                        <td className="row-header ai-Value" style={{ width: 160 }}>
                            <div className="row-header-wrap">
                                <div><img src={Images.icon2} alt="AI Value" /></div>
                                <div>AI Value</div>
                            </div>
                        </td>
                        <td className="vertical-align-top" style={{ backgroundColor: '#f1f1f1' }}>
                            <div className="ai-value-roadmap-wrap">
                                <div className="ai-value-roadmap-item ai-value-line2" style={{ minWidth: 120 }}>
                                    <div className={`ai-value-roadmap-item-box ai-value-line2 ${AI_VALUE_0 ? '' : 'disabled-timeline'}`}>
                                        Priortize Initial <br /> AI use cases
                                    </div>
                                    <span className="ai-value-item-one-line"></span>
                                    <span className="ai-value-item-one-line2"></span>
                                </div>
                                <div className="ai-value-roadmap-item ai-value-line2" style={{ minWidth: 145 }}>
                                    <div className={`ai-value-roadmap-item-box  ai-value-line2 ${AI_VALUE_1 ? '' : 'disabled-timeline'}`}>
                                        Define value for initial <br /> AI use cases
                                    </div>
                                    <span className="ai-value-item-two-line"></span>
                                    <span className="ai-value-item-two-line2"></span>
                                </div>
                                <div className="ai-value-roadmap-item ai-value-line2" style={{ minWidth: 132 }}>
                                    <div className={`ai-value-roadmap-item-box ai-value-line2 ${AI_VALUE_2 ? '' : 'disabled-timeline'}`}>
                                        Run initial AI piolots
                                    </div>
                                    <span className="ai-value-item-three-line"></span>
                                    <span className="ai-value-item-three-line2"></span>
                                    <span className="ai-value-item-three-line3"></span>
                                </div>
                                <div className="ai-value-roadmap-item  ai-value-line2" style={{ minWidth: 152 }}>
                                    <div className={`ai-value-roadmap-item-box ai-value-line2 ${AI_VALUE_3 ? '' : 'disabled-timeline'}`}>
                                        Track value of initial <br /> use cases
                                    </div>
                                    <span className="ai-value-item-four-line"></span>
                                    <span className="ai-value-item-four-line2"></span>
                                    <span className="ai-value-item-four-line3"></span>
                                    <div className={`ai-value-roadmap-item-box  ai-value-line2 ${AI_VALUE_4 ? '' : 'disabled-timeline'}`}
                                        style={{ position: 'relative', left: 117, marginTop: 140 }}>
                                        Introduce product <br /> management practices
                                    </div>
                                    <span className="ai-value-item-four-line4"></span>
                                    <span className="ai-value-item-four-line5"></span>
                                </div>
                                <div className="ai-value-roadmap-item ai-value-line2"
                                    style={{ minWidth: 162 }}>
                                    <div className={`ai-value-roadmap-item-box  ai-value-line2 ${AI_VALUE_5 ? '' : 'disabled-timeline'}`}>
                                        Establish process to <br /> Priortize AI portfolio
                                    </div>
                                </div>
                                <div className="ai-value-roadmap-item ai-value-line2" style={{ minWidth: 140 }}>
                                    <div className={`ai-value-roadmap-item-box ai-value-line2 ${AI_VALUE_6 ? '' : 'disabled-timeline'}`}>
                                        Implement AI FindOps practices
                                    </div>
                                    <span className="ai-value-item-five-line"></span>
                                    <span className="ai-value-item-five-line2"></span>
                                    <div className={`ai-value-roadmap-item-box ai-value-line2 ${AI_VALUE_7 ? '' : 'disabled-timeline'}`}
                                        style={{ marginTop: 90 }}>
                                        launch an initial AI prodcut
                                    </div>
                                    <span className="ai-value-item-five-line3"></span>
                                    <span className="ai-value-item-five-line4"></span>
                                </div>
                                <div className="ai-value-roadmap-item" style={{ minWidth: 185 }}>
                                    <div className={`ai-value-roadmap-item-box ai-value-line2 ${AI_VALUE_8 ? '' : 'disabled-timeline'}`}>
                                        Set up AI value monitoring <br />system
                                    </div>
                                    <div className={`ai-value-roadmap-item-box ai-value-line2 ${AI_VALUE_9 ? '' : 'disabled-timeline'}`}
                                        style={{ width: 142, marginLeft: 35, marginTop: 100 }}>
                                        Establish an <br /> AI product portfolio
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }

    const renderAIOrganization = () => {
        const AI_ORGANISATION_0 = getTaskStatus(2, Constant.AI_ORGANISATION[0]);
        const AI_ORGANISATION_1 = getTaskStatus(2, Constant.AI_ORGANISATION[1]);
        const AI_ORGANISATION_2 = getTaskStatus(2, Constant.AI_ORGANISATION[2]);
        const AI_ORGANISATION_3 = getTaskStatus(2, Constant.AI_ORGANISATION[3]);
        const AI_ORGANISATION_4 = getTaskStatus(2, Constant.AI_ORGANISATION[4]);
        const AI_ORGANISATION_5 = getTaskStatus(2, Constant.AI_ORGANISATION[5]);
        const AI_ORGANISATION_6 = getTaskStatus(2, Constant.AI_ORGANISATION[6]);

        return (<table className="ai-table ai-strategy-table-roadmap">
            <tbody>
                <tr>
                    <td className="row-header ai-Organization" style={{ maxWidth: 150, width: 145 }}>
                        <div className="row-header-wrap">
                            <div><img src={Images.icon3} alt="AI Organization" /></div>
                            <div>AI Organization</div>
                        </div>
                    </td>
                    <td className="vertical-align-top" style={{ backgroundColor: '#f1f1f1' }}>
                        <div className="ai-Organization-roadmap-wrap">
                            <div className="ai-Organization-roadmap-item ai-Organization-line2" style={{ minWidth: 185 }}>
                                <div className={`ai-Organization-roadmap-item-box ai-Organization-line2 ${AI_ORGANISATION_0 ? '' : 'disabled-timeline'}`}>
                                    Create an AI resourcing plan
                                </div>
                                <span className="ai-Organization-item-one-line"></span>
                                <span className="ai-Organization-item-one-line2"></span>
                                <span className="ai-Organization-item-one-line3"></span>
                                <span className="ai-Organization-item-one-line4"></span>
                                <span className="ai-Organization-item-one-line5"></span>
                            </div>
                            <div className="ai-Organization-roadmap-item ai-Organization-line2" style={{ minWidth: 162 }}>
                                <div className={`ai-Organization-roadmap-item-box ai-Organization-line2 ${AI_ORGANISATION_1 ? '' : 'disabled-timeline'}`}>
                                    Set up an AI community <br />of practice
                                </div>
                                <div className={`ai-Organization-roadmap-item-box ai-Organization-line2 ${AI_ORGANISATION_2 ? '' : 'disabled-timeline'}`}>
                                    Appoint an AI leader
                                </div>
                                <span className="ai-Organization-item-two-line"></span>
                            </div>
                            <div className="ai-Organization-roadmap-item ai-Organization-line2" style={{ minWidth: 311, marginLeft: -100 }}>
                                <div className={`ai-Organization-roadmap-item-box ai-Organization-line2 ${AI_ORGANISATION_3 ? '' : 'disabled-timeline'}`}>
                                    Form initial external AI partnerships
                                </div>
                                <span className="ai-Organization-item-three-line"></span>
                                <span className="ai-Organization-item-three-line2"></span>
                            </div>
                            <div className="ai-Organization-roadmap-item ai-Organization-line2" style={{ minWidth: 255, marginLeft: -100 }}>
                                <div className={`ai-Organization-roadmap-item-box ai-Organization-line2 ${AI_ORGANISATION_4 ? '' : 'disabled-timeline'}`}>
                                    Set up up an initial AI <br /> team/center of excellence
                                </div>
                                <span className="ai-Organization-item-four-line"></span>
                                <span className="ai-Organization-item-four-line2"></span>
                            </div>

                            <div className="ai-Organization-roadmap-item ai-Organization-line2" style={{ minWidth: 205 }}>
                                <div className={`ai-Organization-roadmap-item-box ai-Organization-line2 ${AI_ORGANISATION_5 ? '' : 'disabled-timeline'}`}>
                                    Establish AI target operating model
                                </div>
                                <div className={`ai-Organization-roadmap-item-box ai-Organization-line2 ${AI_ORGANISATION_6 ? '' : 'disabled-timeline'} `}
                                    style={{ marginTop: 60 }}>
                                    Set up process to manage AI  <br /> partnerships
                                </div>
                            </div>


                        </div>
                    </td>
                </tr>
            </tbody>
        </table>)
    }

    const renderAIPeopleAndCulture = () => {
        const AI_PEOPLE_AND_CULTURE_0 = getTaskStatus(3, Constant.AI_PEOPLE_AND_CULTURE[0]);
        const AI_PEOPLE_AND_CULTURE_1 = getTaskStatus(3, Constant.AI_PEOPLE_AND_CULTURE[1]);
        const AI_PEOPLE_AND_CULTURE_2 = getTaskStatus(3, Constant.AI_PEOPLE_AND_CULTURE[2]);
        const AI_PEOPLE_AND_CULTURE_3 = getTaskStatus(3, Constant.AI_PEOPLE_AND_CULTURE[3]);
        const AI_PEOPLE_AND_CULTURE_4 = getTaskStatus(3, Constant.AI_PEOPLE_AND_CULTURE[4]);
        const AI_PEOPLE_AND_CULTURE_5 = getTaskStatus(3, Constant.AI_PEOPLE_AND_CULTURE[5]);
        const AI_PEOPLE_AND_CULTURE_6 = getTaskStatus(3, Constant.AI_PEOPLE_AND_CULTURE[6]);
        const AI_PEOPLE_AND_CULTURE_7 = getTaskStatus(3, Constant.AI_PEOPLE_AND_CULTURE[7]);

        return (<table className="ai-table ai-strategy-table-roadmap">
            <tbody>
                <tr>
                    <td className="row-header ai-culture" style={{ width: 160 }}>
                        <div className="row-header-wrap">
                            <div><img src={Images.icon4} alt="AI People and culture" /></div>
                            <div>AI People and <br /> culture</div>
                        </div>
                    </td>
                    <td className="vertical-align-top" style={{ backgroundColor: '#f1f1f1' }}>
                        <div className="ai-culture-roadmap-wrap">
                            <div className="ai-culture-roadmap-item ai-culture-line2" style={{ minWidth: 185 }}>
                                <div className={`ai-culture-roadmap-item-box ai-culture-line2 ${AI_PEOPLE_AND_CULTURE_0 ? '' : 'disabled-timeline'} `}>
                                    Create an initial AI workforce plan
                                </div>
                                <span className="ai-culture-item-one-line"></span>
                                <span className="ai-culture-item-one-line2"></span>
                                <span className="ai-culture-item-one-line3"></span>
                                <span className="ai-culture-item-one-line4"></span>
                                <span className="ai-culture-item-one-line5"></span>
                            </div>
                            <div className="ai-culture-roadmap-item ai-culture-line2" style={{ minWidth: 185 }}>
                                <div className={`ai-culture-roadmap-item-box ai-culture-line2 ${AI_PEOPLE_AND_CULTURE_1 ? '' : 'disabled-timeline'} `}>
                                    Set up process for review of roles <br />and job redesign
                                </div>
                                <div className={`ai-culture-roadmap-item-box ai-culture-line2 ${AI_PEOPLE_AND_CULTURE_2 ? '' : 'disabled-timeline'} `}>
                                    Create an AI change management plan
                                </div>
                                <span className="ai-culture-item-two-line"></span>
                                <span className="ai-culture-item-two-line2"></span>
                                <div className={`ai-culture-roadmap-item-box ai-culture-line2 ${AI_PEOPLE_AND_CULTURE_3 ? '' : 'disabled-timeline'} `} style={{ marginTop: 75 }}>
                                    Create initial AI awarness campaigns
                                </div>

                            </div>
                            <div className="ai-culture-roadmap-item ai-culture-line2" style={{ minWidth: 275 }}>
                                <div className={`ai-culture-roadmap-item-box ai-culture-line2 ${AI_PEOPLE_AND_CULTURE_4 ? '' : 'disabled-timeline'} `}>
                                    Set up process to evalute AI <br /> workforce impact
                                </div>
                                <div className={`ai-culture-roadmap-item-box ai-culture-line2 ${AI_PEOPLE_AND_CULTURE_5 ? '' : 'disabled-timeline'} `} style={{ marginTop: 75 }}>
                                    Launch an AI literacy program
                                </div>
                                <span className="ai-culture-item-three-line"></span>
                                <span className="ai-culture-item-three-line2"></span>
                                <span className="ai-culture-item-three-line3"></span>

                            </div>
                            <div className="ai-culture-roadmap-item ai-culture-line2" style={{ minWidth: 220 }}>
                                <div className={`ai-culture-roadmap-item-box ai-culture-line2 ${AI_PEOPLE_AND_CULTURE_6 ? '' : 'disabled-timeline'} `}>
                                    Define business champions to <br /> drive AI literacy
                                </div>
                                <div className={`ai-culture-roadmap-item-box ai-culture-line2 ${AI_PEOPLE_AND_CULTURE_7 ? '' : 'disabled-timeline'} `}>
                                    Set up monitoring of employee <br /> readiness for AI
                                </div>

                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>)
    }

    const renderAIGovernance = () => {
        const AI_GOVERNANCE_0 = getTaskStatus(4, Constant.AI_GOVERNANCE[0]);
        const AI_GOVERNANCE_1 = getTaskStatus(4, Constant.AI_GOVERNANCE[1]);
        const AI_GOVERNANCE_2 = getTaskStatus(4, Constant.AI_GOVERNANCE[2]);
        const AI_GOVERNANCE_3 = getTaskStatus(4, Constant.AI_GOVERNANCE[3]);
        const AI_GOVERNANCE_4 = getTaskStatus(4, Constant.AI_GOVERNANCE[4]);
        const AI_GOVERNANCE_5 = getTaskStatus(4, Constant.AI_GOVERNANCE[5]);
        const AI_GOVERNANCE_6 = getTaskStatus(4, Constant.AI_GOVERNANCE[6]);
        const AI_GOVERNANCE_7 = getTaskStatus(4, Constant.AI_GOVERNANCE[7]);
        const AI_GOVERNANCE_8 = getTaskStatus(4, Constant.AI_GOVERNANCE[8]);
        const AI_GOVERNANCE_9 = getTaskStatus(4, Constant.AI_GOVERNANCE[9]);

        return (<table className="ai-table ai-strategy-table-roadmap">
            <tbody>
                <tr>
                    <td className="row-header ai-Governance" style={{ width: 145, maxWidth: 150 }}>
                        <div className="row-header-wrap">
                            <div><img src={Images.icon5} alt="AI Governance" /></div>
                            <div>AI Governance</div>
                        </div>
                    </td>
                    <td className="vertical-align-top" style={{ backgroundColor: '#f1f1f1' }}>
                        <div className="ai-Governance-roadmap-wrap">
                            <div className="ai-Governance-roadmap-item ai-Governance-line2" style={{ minWidth: 185 }}>
                                <div className={`ai-Governance-roadmap-item-box ai-Governance-line2 ${AI_GOVERNANCE_0 ? '' : 'disabled-timeline'}`}>
                                    Identify key AI risks and <br /> mitigation
                                </div>
                                <span className="ai-Governance-item-one-line"></span>
                                <span className="ai-Governance-item-one-line2"></span>
                                <span className="ai-Governance-item-one-line3"></span>
                                <span className="ai-Governance-item-one-line4"></span>
                            </div>
                            <div className="ai-Governance-roadmap-item ai-Governance-line2" style={{ minWidth: 185 }}>
                                <div className={`ai-Governance-roadmap-item-box ai-Governance-line2 ${AI_GOVERNANCE_1 ? '' : 'disabled-timeline'}`}>
                                    Define initial AI policies
                                </div>
                                <div className={`ai-Governance-roadmap-item-box ai-Governance-line2 ${AI_GOVERNANCE_2 ? '' : 'disabled-timeline'}`}>
                                    Establish AI ethical principles
                                </div>
                                <span className="ai-Governance-item-two-line"></span>
                                <span className="ai-Governance-item-two-line2"></span>
                                <span className="ai-Governance-item-two-line3"></span>
                                <span className="ai-Governance-item-two-line4"></span>
                                <div className={`ai-Governance-roadmap-item-box ai-Governance-line2 ${AI_GOVERNANCE_3 ? '' : 'disabled-timeline'}`} style={{ marginTop: 50, minWidth: 150 }}>
                                    Gain buy-in for AI  <br />governance approach
                                </div>
                                <span className="ai-Governance-item-two-line5"></span>
                                <span className="ai-Governance-item-two-line6"></span>
                                <span className="ai-Governance-item-two-line7"></span>
                            </div>
                            <div className="ai-Governance-roadmap-item ai-Governance-line2" style={{ minWidth: 185 }}>
                                <div className={`ai-Governance-roadmap-item-box ai-Governance-line2 ${AI_GOVERNANCE_4 ? '' : 'disabled-timeline'}`}>
                                    Define decision rights for <br /> AI governance
                                </div>
                                <span className="ai-Governance-item-three-line"></span>
                                <span className="ai-Governance-item-three-line2"></span>
                            </div>
                            <div className="ai-Governance-roadmap-item ai-Governance-line2" style={{ minWidth: 255 }}>
                                <div className={`ai-Governance-roadmap-item-box ai-Governance-line2 ${AI_GOVERNANCE_5 ? '' : 'disabled-timeline'}`}>
                                    Set enforcement process
                                </div>
                                <span className="ai-Governance-item-four-line"></span>
                                <span className="ai-Governance-item-four-line2"></span>
                            </div>
                            <div className="ai-Governance-roadmap-item ai-Governance-line2" style={{ minWidth: 185 }}>
                                <div className={`ai-Governance-roadmap-item-box ai-Governance-line2 ${AI_GOVERNANCE_6 ? '' : 'disabled-timeline'}`}>
                                    Set up cross-functional <br /> AI-governance board
                                </div>
                                <span className="ai-Governance-item-five-line"></span>
                                <span className="ai-Governance-item-five-line2"></span>
                            </div>
                            <div className="ai-Governance-roadmap-item ai-Governance-line2" style={{ minWidth: 255 }}>
                                <div className={`ai-Governance-roadmap-item-box ai-Governance-line2 ${AI_GOVERNANCE_7 ? '' : 'disabled-timeline'}`}>
                                    Define target AI governance operating model
                                </div>
                                <div className={`ai-Governance-roadmap-item-box ai-Governance-line2 ${AI_GOVERNANCE_8 ? '' : 'disabled-timeline'}`}>
                                    Use AI literacy programs for AI governance
                                </div>

                            </div>
                            <div className="ai-Governance-roadmap-item ai-Governance-line2" style={{ minWidth: 223 }}>
                                <div className={`ai-Governance-roadmap-item-box ai-Governance-line2 ${AI_GOVERNANCE_9 ? '' : 'disabled-timeline'}`}>
                                    Pilot AI governance tooling
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>)
    }

    const render = () => {
        if (aiMaturityEval && aiMaturityEval.length) {
            return (
                <>
                    <div className="month-wrap-table mx-auto">
                        <div className="only-with-200"></div>
                        <div className="only-month-wrap">
                            <div>Month 1</div>
                            <div>Month 2</div>
                            <div>Month 3</div>
                            <div>Month 4</div>
                            <div>Month 5</div>
                            <div>Month 6</div>
                            <div>Month 7</div>
                            <div>Month 8</div>
                            <div>Month 9</div>
                            <div>Month 10</div>
                            <div>Month 11</div>
                            <div>Month 12</div>
                        </div>
                    </div>
                    <div className="ai-table-wrapper mt-4 mx-auto" style={{ maxHeight: '60vh', overflowY: 'auto', width: 1120 }}>
                        {/* AI Strategy */}
                        {renderAIStrategy()}
                        {/* AI Value */}
                        {renderAIValue()}
                        {/* AI Organization */}
                        {renderAIOrganization()}
                        {/* AI People and culture */}
                        {renderAIPeopleAndCulture()}
                        {/* AI Governance */}
                        {renderAIGovernance()}
                        {/* AI Engineering */}
                        {renderAIEnigneering()}
                        {/* AI Data */}
                        {renderAIData()}
                    </div>
                </>
            )
        }
    }
    return render();
}

export default AIRoadmapTable